'use strict';

(function () {
    const renderAttributes = (map) => {
        return Object.keys(map).map((key) => {
            const attrName = String(key).escapeHtml();
            const attrValue = String(map[key]).escapeAttr();
            return `${attrName}="${attrValue}"`;
        }).join(' ');
    };

    const registerNodeFonts = function () {
        if (this.nodeType !== Node.ELEMENT_NODE) {
            return;
        }
        const family = this.style.fontFamily;
        if (family) {
            Fotobook.store.commit('Fonts/loadFontByFamily', family);
        }
        const children = this.childNodes;
        for (let i = 0, l = children.length; i < l; i++) {
            registerNodeFonts.call(children[i]);
        }
    };

    const registerFonts = function ($e) {
        $e.each(registerNodeFonts);
    };

    const captionToRedactorPass1 = function () {
        if (!this) {
            return;
        }
        const list = Array.prototype.slice.call(this);
        for (let i = 0, len = list.length; i < len; i++) {
            const e = list[i];
            if (e.nodeType === Node.TEXT_NODE) {
                const $parent = $(e.parentNode);
                const em = ['italic', 'oblique'].indexOf($parent.css('font-style')) >= 0 && $parent.closest('i,em').length;
                const strong = ($parent.css('font-weight') > 400 || $parent.css('font-weight') === 'bold') && !$parent.closest('b,strong').length;

                if (em) {
                    $(list[i]).wrap('<em></em>');
                }
                if (strong) {
                    $(list[i]).wrap('<strong></strong>');
                }
            } else if (e.nodeType === Node.ELEMENT_NODE) {
                captionToRedactorPass1.call(e.childNodes);
                $(list[i]).css({
                    'font-weight': '',
                    'font-style': '',
                }).removeAttr('id');
                if (e.nodeName === 'BR' && e.parentNode.nodeName === 'P') {
                    const tmp = list.slice(i + 1);
                    if (!tmp.length || Fotobook.book.textContentEmpty(tmp)) {
                        $(e).remove();
                    }
                }
            }
        }
    };

    const captionToRedactorPass2 = function () {
        if (!this) {
            return;
        }
        var list = Array.prototype.slice.call(this),
            e, i, len;
        for (i = 0, len = list.length; i < len; i++) {
            e = list[i];
            if (e.nodeType === Node.ELEMENT_NODE) {
                captionToRedactorPass2.call(e.childNodes);
                if (e.nodeName === 'P' && list.length === 1) {
                    $(e).replaceWith(e.childNodes);
                }
            }
        }
    };

    const captionToRedactor = function () {
        captionToRedactorPass1.call(this);
        this.html(this.html().replace(/\<\/p\>\s*\<p\>/g, "<br>"));
        captionToRedactorPass2.call(this);
    };

    const styleToAttribute = (styles) => {
        return Object.keys(styles).map((key) => `${key}: ${styles[key]}`).join(';');
    };

    const CAPTION_CONTENT_TEMPLATE = '<div class="{classes}" style="font-size:{fs_em}em;" data-font-size="{fs_px}">{content}</div>';

    const getCaptionContentRich = (caption, content) => {
        const $tmp = $($.parseHTML(['<div class="tmp-text" style="visibility:hidden;">', content.content, '</div>'].join('')));

        registerFonts($tmp);
        $('body').append($tmp);
        captionToRedactor.call($tmp);
        content.content = $tmp.html();
        $tmp.remove();
        return CAPTION_CONTENT_TEMPLATE.supplant(content);
    };

    const getCaptionContentPlain = (caption, content) => {
        var $content = $($.parseHTML('<div>' + content.content + '</div>')),
            $textContent = $content.find('.text-content:first'),
            childNodes,
            contentString;

        registerFonts($content);
        if (!$textContent.length) {
            childNodes = $content[0].childNodes;
            if (childNodes.length === 1 && childNodes[0].nodeType === Node.ELEMENT_NODE) {
                $textContent = $content;
            }
        }
        if ($textContent.length) {
            content.fs_px = parseFloat($textContent.attr('data-font-size') || caption.size) || content.fs_base;
            content.fs_em = content.fs_px / content.fs_base;
            $textContent.addClass('text-content');
            if ($textContent.text() === '') {
                $textContent.html('&nbsp;'); // чтобы текст выравнивался по центру в FF (!!!плохая затея!!!)
            }
            $textContent.css({
                'font-size': `${content.fs_em}em`,
                padding: `0 ${content.safe}`,
                margin: `0 -${content.safe}`,
            });
            $textContent.attr('data-font-size', content.fs_px);
            contentString = $textContent.outerhtml();
        } else {
            contentString = CAPTION_CONTENT_TEMPLATE.supplant(content);
        }
        return contentString;
    };

    const CAPTION_TEMPLATE = '<div class="caption" {captionAttributes}>{content}</div>';

    Fotobook.book.captions = {
        getCaptionAlign(align) {
            if (align === 'end') {
                return 'right';
            }
            if (align === 'start') {
                return 'left';
            }
            if (!['left', 'right', 'center', 'justify'].includes(align)) {
                return 'center';
            }
            return align;
        },
        getValidatedVerticalAlignValue(value) {
            const CaptionAlign = Fotobook.CaptionAlign;
            return [
                CaptionAlign.START,
                CaptionAlign.CENTER,
                CaptionAlign.END,
            ].includes(value) ? value : CaptionAlign.CENTER;
        },
        getCaptionStyles(attributes) {
            const fsBase = Fotobook.book.getBaseFontSize();
            // Отбрасываем дробную часть после 2 знака после запятой (без округления)
            // так получше сходятся переносы в текстах, но не идеально
            // (http://bt.web100.com.ua/view.php?id=45063)
            const fontSize = Math.floor(fsBase * attributes['data-dx'] / Fotobook.book.BASE_SIZE * 100) / 100;

            return {
                'background-color': attributes['data-bgcolor'],
                color: attributes['data-fcolor'],
                // {family} обрамлять апострофами НЕ НУЖНО. Они обрамляются в функции, которая готовит family-строчку
                'font-family': attributes['data-family'],
                'font-size': `${fontSize}em`,
                '--caption-line-height': attributes['data-line-height'],
            };
        },
        getCaptionDataAttributes(caption, dX, spine) {
            Fotobook.store.commit('Fonts/loadFontById', caption.font_id);

            /** @var Font */
            const font = Fotobook.store.getters['Fonts/getFontById'](caption.font_id);
            const verticalAlign = spine ? Fotobook.CaptionAlign.CENTER : this.getValidatedVerticalAlignValue(caption.vertical_align_current ?? caption.vertical_align_initial);

            return {
                'data-align': this.getCaptionAlign(caption.align),
                'data-bgcolor': caption.bgcolor,
                'data-dx': dX,
                'data-family': font.family,
                'data-fcolor': caption.color,
                'data-font-id': caption.font_id,
                'data-font-size': caption.size,
                'data-font-style': caption.italic ? 'italic' : 'normal',
                'data-font-weight': caption.bold ? 'bold' : 'normal',
                'data-id': caption.id,
                'data-line-height': caption.line_height,
                'data-text-decoration': caption.underline ? 'underline' : 'none',
                'data-type': caption.type,
                'data-vertical_align': verticalAlign,
            };
        },
        getCaptionAttributes(caption, dX, spine) {
            const captionDataAttributes = this.getCaptionDataAttributes(caption, dX, spine);
            return {
                dir: 'auto',
                ...captionDataAttributes,
                style: styleToAttribute(this.getCaptionStyles(captionDataAttributes)),
            };
        },
        drawCaption(caption, dX, spine) {
            if (![Fotobook.CaptionType.PLAIN, Fotobook.CaptionType.RICH].includes(caption.type)) {
                throw new Error(`Unknown caption.type: ${caption.type}`);
            }

            const rich = caption.type === Fotobook.CaptionType.RICH;
            const fs_base = Fotobook.book.getBaseFontSize();
            const content = {
                fs_base,
                classes: [
                    'text-content',
                    ...rich ? ['redactor-general'] : [],
                ].join(' '),
                content: caption.content || '',
                fs_px: caption.size,
                fs_em: caption.size / fs_base,
            };

            return CAPTION_TEMPLATE.supplant({
                content: rich ? getCaptionContentRich(caption, content) : getCaptionContentPlain(caption, content),
                captionAttributes: renderAttributes(this.getCaptionAttributes(caption, dX, spine)),
            });
        },
    };
})();
